/* eslint-disable func-names */
/* eslint-disable react/jsx-indent */
/* eslint-disable @typescript-eslint/indent */
import React, {
    createContext, useContext, useEffect, useState, useMemo,
} from 'react';
import {
    PublicClientApplication,
    AuthenticationResult,
    AccountInfo,
    EventType,
} from '@azure/msal-browser';
import { msalConfig } from '../config/authConfig';

interface MsalContextType {
    instance: PublicClientApplication | null;
    accounts: AccountInfo[];
    inProgress: boolean;
}

const MsalContext = createContext<MsalContextType>({
    instance: null,
    accounts: [],
    inProgress: false,
});

export const useMsal = () => useContext(MsalContext);

export const MsalProvider: React.FC<{ children: React.ReactNode }> = function ({
    children,
}) {
    const [instance, setInstance] = useState<PublicClientApplication | null>(
        null,
    );
    const [accounts, setAccounts] = useState<AccountInfo[]>([]);
    const [inProgress] = useState<boolean>(false);

    useEffect(() => {
        const msalInstance = new PublicClientApplication(msalConfig);
        setInstance(msalInstance);

        msalInstance.initialize().then(() => {
            // Account selection logic is app dependent. Adjust as needed for different use cases.
            const allAccounts = msalInstance.getAllAccounts();
            setAccounts(allAccounts);

            msalInstance.addEventCallback(async (event) => {
                if (event.eventType === EventType.LOGIN_SUCCESS) {
                    const result = event.payload as AuthenticationResult;
                    console.log('Res', result);
                    setAccounts(msalInstance.getAllAccounts());
                }
            });
        }).catch((error) => {
            console.error('MSAL initialization error:', error);
        });
    }, []);

    const contextValue = useMemo(() => ({
        instance,
        accounts,
        inProgress,
    }), [instance, accounts, inProgress]);

    return (
        <MsalContext.Provider value={contextValue}>
            {children}
        </MsalContext.Provider>
    );
};
